import { render, staticRenderFns } from "./logistics-details.vue?vue&type=template&id=1309962c&scoped=true"
import script from "./logistics-details.ts?vue&type=script&lang=ts&external"
export * from "./logistics-details.ts?vue&type=script&lang=ts&external"
import style0 from "./logistics-details.scoped.scss?vue&type=style&index=0&id=1309962c&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1309962c",
  null
  
)

export default component.exports